// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-6a7ec924]:export {\n  menuBg: white;\n  menuText: rgba(0, 0, 0, 0.65);\n  menuActiveText: #005BB5;\n}\n\n/* Mixins */\n.dialog-footer[data-v-6a7ec924] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}", ""]);
// Exports
module.exports = exports;
